export const validationPatterns = {
  emailPattern: /^[\w._-]+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
  email : /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: /^[0-9 _.()-+*]+$/i,
  login: /^[a-z0-9@_-]+$/i,
  loginOrEmail: /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9]|[_-](?=[a-zA-Z0-9])){2,127}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
  password: /^[a-z0-9!@#\\$%\\^\\&*\\)\\(+=._-]+$/i,
  ip: /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.|$)){4}\b$/,
  communityName: new RegExp("^[A-Za-z0-9!#$%&'()*+,./;:>=<@\\[\\]\\^_-]*$"),
  hostname: /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/,
  netmask: /^[1]$/,
  url: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/
}